export const daysOfWeek = [
  "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
];

export const columnLabels = {
  partner_id: "Partner ID",
  acceptTerms: "Accept Terms",
  partner_type: "Partner Type",
  partner_name: "Partner Name",
  partner_email: "Partner Email",
  partner_mobile: "Partner Mobile",
  partner_noOfUserLicenses: "No. of User Licenses",
  tenantId: "Tenant ID",
  tenantDetails: "Tenant Name",
  "tenantDetails.tenant_name": "Tenant Name",
  "partnerTypeDetails.value": "Partner Type",
  "bank.bankName": "Bank Name",
  "bank.ifscCode": "IFSC Code",
  "bank.accountNumber": "Account Number",
  "address.partner_address1": "Address Line 1",
  "address.partner_address2": "Address Line 2",
  "address.partner_city": "City",
  "address.partner_pincode": "PinCode",
  "address.partner_postCode": "Post Code",
  "address.partner_state": "State",
  "address.partner_country": "Country",
  warehouse: "Warehouse",
  moduleAccess: "Module Access (IDs)",
  "moduleDetails.value": "Module Access",
  "facilityDetails.value": "Facility Access",
  "operationalHours.dayRange": "Operational Day",
  "operationalHours.timeRange.open": "Opening Time",
  "operationalHours.timeRange.close": "Closing Time",
  status: "Status",
  createdBy: "Created By",
  updatedBy: "Updated By",
  createdAt: "Created Date",
  updatedAt: "Updated Date",
  acceptTerms: "Accepted Terms",
  terms: "Terms and Conditions"
};

export const defaultVisibleFields = [
  "partner_id",
  "partner_name",
  "partner_email",
  "partner_mobile",
  "partnerTypeDetails.value",
  "tenantDetails.tenant_name",
  "partner_noOfUserLicenses",
  "address.partner_city",
  "status"
];

export const getColumnWidth = (fieldName) => {
  const widthMap = {
    partner_name: 180,
    partner_email: 200,
    partner_mobile: 140,
    "partnerTypeDetails.value": 160,
    "tenantDetails.tenant_name": 180,
    partner_noOfUserLicenses: 150,
    "address.partner_city": 150,
    status: 100,
    createdAt: 160,
    updatedAt: 160
  };
  return widthMap[fieldName] || 160;
};

export const getValueFormatter = (fieldName) => {
  switch (fieldName) {
    case "partner_noOfUserLicenses":
      return (params) =>
        params ? `${Number(params).toLocaleString()} Licenses` : "";
    case "partner_mobile":
      return (params) => (params);
    case "createdAt":
    case "updatedAt":
      return (params) =>
        params ? new Date(params).toLocaleString() : "";
    default:
      return undefined;
  }
};

export const getColumnLabel = (field, startCaseFn) => {
  return columnLabels[field] || startCaseFn(field);
};

// Helper to rebuild nested object from flat fields
export const unflattenPartnerObject = (flatObj) => {
  const result = {};

  Object.entries(flatObj).forEach(([key, value]) => {
    const keys = key.split(".");
    let current = result;

    keys.forEach((k, i) => {
      if (i === keys.length - 1) {
        current[k] = value;
      } else {
        current[k] = current[k] || {};
        current = current[k];
      }
    });
  });

  return result;
};

// Convert operationalHours array into [{dayRange, timeRange:{open,close}}]
export function parseOperationalHours(operationalHours) {
  if (!operationalHours) return [];

  return operationalHours.split(',').map(item => {
    // Normalize full-width colon or weird spaces
    item = item.replace(/：/g, ':').trim();

    // Split on the first colon only
    const [dayRaw, ...timeParts] = item.split(':');
    const timeRaw = timeParts.join(':').trim(); // join back in case time has extra colon

    // Normalize day capitalization
    const day = daysOfWeek.find(d => d.toUpperCase() === dayRaw.trim().toUpperCase()) || dayRaw.trim();

    let open = null, close = null;

    if (timeRaw) {
      // Normalize all dash types to standard '-'
      const normalizedTime = timeRaw.replace(/[–—−]/g, '-'); // en dash, em dash, minus sign
      const [o, c] = normalizedTime.split('-').map(str => str.trim());
      open = o || null;
      close = c || null;
    }

    console.log({
      dayRange: day,
      timeRange: { open, close }
    });


    return {
      dayRange: day,
      timeRange: { open, close }
    };
  });
}


export const termsText = `By registering on the Partner Portal, the Partner agrees to comply with all applicable laws and platform policies,
 maintain confidentiality of data accessed through the system, and use the portal solely for authorized business purposes. 
 The Partner is responsible for the accuracy of information shared, the security of login credentials,
  and any actions performed under their account. System Owner reserves the right to review,
   suspend, or terminate access in case of misuse, non-compliance, or breach of these terms.
    Continued use of the portal constitutes acceptance of all Terms & Conditions and related policies.`